export default {
	containers_auth_components_login: {
		f_required: 'Обов\'язкове поле',
		password_placeholder: 'Пароль*',
		username_placeholder: 'Ім\'я користувача*',
		submit: 'Підтвердити',
	},
}